"use strict";
/*!
 * Copyright 2019 Google Inc. All Rights Reserved.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *      http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

var _classCallCheck = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/classCallCheck");

var _createClass = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createClass");

var _possibleConstructorReturn = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/getPrototypeOf");

var _get = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/get");

var _inherits = require("C:\\Users\\TaeYongKong\\Documents\\GitHub\\deliquick-app-master-v2\\deliquick-app-master\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ResourceStream = void 0;

var stream_1 = require("stream");

var ResourceStream =
/*#__PURE__*/
function (_stream_1$Transform) {
  _inherits(ResourceStream, _stream_1$Transform);

  function ResourceStream(args, requestFn) {
    var _this;

    _classCallCheck(this, ResourceStream);

    var options = Object.assign({
      objectMode: true
    }, args.streamOptions);
    _this = _possibleConstructorReturn(this, _getPrototypeOf(ResourceStream).call(this, options));
    _this._ended = false;
    _this._maxApiCalls = args.maxApiCalls === -1 ? Infinity : args.maxApiCalls;
    _this._nextQuery = args.query;
    _this._reading = false;
    _this._requestFn = requestFn;
    _this._requestsMade = 0;
    _this._resultsToSend = args.maxResults === -1 ? Infinity : args.maxResults;
    return _this;
  }
  /* eslint-disable  @typescript-eslint/no-explicit-any */


  _createClass(ResourceStream, [{
    key: "end",
    value: function end() {
      var _get2;

      this._ended = true;

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return (_get2 = _get(_getPrototypeOf(ResourceStream.prototype), "end", this)).call.apply(_get2, [this].concat(args));
    }
  }, {
    key: "_read",
    value: function _read() {
      var _this2 = this;

      if (this._reading) {
        return;
      }

      this._reading = true; // Wrap in a try/catch to catch input linting errors, e.g.
      // an invalid BigQuery query. These errors are thrown in an
      // async fashion, which makes them un-catchable by the user.

      try {
        this._requestFn(this._nextQuery, function (err, results, nextQuery) {
          if (err) {
            _this2.destroy(err);

            return;
          }

          _this2._nextQuery = nextQuery;

          if (_this2._resultsToSend !== Infinity) {
            results = results.splice(0, _this2._resultsToSend);
            _this2._resultsToSend -= results.length;
          }

          var more = true;
          var _iteratorNormalCompletion = true;
          var _didIteratorError = false;
          var _iteratorError = undefined;

          try {
            for (var _iterator = results[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
              var result = _step.value;

              if (_this2._ended) {
                break;
              }

              more = _this2.push(result);
            }
          } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
          } finally {
            try {
              if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
              }
            } finally {
              if (_didIteratorError) {
                throw _iteratorError;
              }
            }
          }

          var isFinished = !_this2._nextQuery || _this2._resultsToSend < 1;
          var madeMaxCalls = ++_this2._requestsMade >= _this2._maxApiCalls;

          if (isFinished || madeMaxCalls) {
            _this2.end();
          }

          if (more && !_this2._ended) {
            setImmediate(function () {
              return _this2._read();
            });
          }

          _this2._reading = false;
        });
      } catch (e) {
        this.destroy(e);
      }
    }
  }]);

  return ResourceStream;
}(stream_1.Transform);

exports.ResourceStream = ResourceStream;